import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { DECK_STUDY_CARD_QUERY_CONFIG } from "#deck-study-card-query-config";

const ALL_DECK_STUDY_CARDS_CONFIG = {
  ...DECK_STUDY_CARD_QUERY_CONFIG,
  where: { fsrsCardId: { isNotNull: true } },
} as const;

export function useGetAllDeckStudyCardsQueryKey() {
  const [db] = useContextSelectors(ActorDatabaseContext, (context) => context.db);
  const withTableChangeVersion = useActorTableChangeVersion(
    "userCard",
    ALL_DECK_STUDY_CARDS_CONFIG,
  );
  return () => withTableChangeVersion(["allDeckStudyCards", { db }] as const);
}

export const [useAllDeckStudyCardsQueryOptions, allDeckStudyCardsQueryFn] = createUseQueryOptions(
  useGetAllDeckStudyCardsQueryKey,
  async ({ queryKey: [_, { db }] }) => {
    // No `staleTime: 0` override needed: the write-clock freshness check already
    // refuses to serve this read from cache unless it is provably current with
    // every committed write to the tables it depends on.
    return db(import.meta.location).query.userCard.findMany(ALL_DECK_STUDY_CARDS_CONFIG);
  },
);
